import { showDeleteCouncilState } from '@/atoms';
import { useDeleteCouncil } from '@/services/councils';
import { Button } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { useQueryClient } from '@tanstack/react-query';
import { ModalLayout } from 'moh-ui';
import { useRecoilState } from 'recoil';

export default function DeleteCouncilModal() {
    const [show, setShow] = useRecoilState(showDeleteCouncilState);

    const {
        mutate: deleteCouncil,
        isPending: deletingCouncil,
    } = useDeleteCouncil();

    const queryClient = useQueryClient();


    const handleDeleteCouncil = async () => {
        if (!show?.council) return;

        deleteCouncil(show.council.id!, {
            onSuccess: (data) => {
                if (data.success) {
                    notifications.show({
                        title: "Success",
                        message: "Council deleted successfully",
                        color: "green",
                    });
                    queryClient.invalidateQueries({
                        queryKey: ['councils']
                    });
                    setShow(null);
                } else {
                    notifications.show({
                        title: "Error",
                        message: data.message || "Something went wrong",
                        color: "red",
                    });
                }
            },
            onError: (error) => {
                console.error(error);
                notifications.show({
                    title: "Error",
                    message: error.message || "An error occurred while deleting the council",
                    color: "red",
                });
            },
        });
    }

    return (
        <ModalLayout
            open={Boolean(show?.show)}
            onClose={() => setShow(null)}
        >
            <div className="sm:flex sm:items-start">
                <div className="text-center sm:mt-0 sm:ml-4 sm:text-left">
                    <h3 className="text-lg font-medium leading-6 text-gray-900">Delete Council</h3>
                    <div className="mt-2">
                        <p className="text-sm text-gray-500">
                            Are you sure you want to delete this council? This action cannot be undone.
                        </p>
                    </div>
                </div>
            </div>
            <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse gap-5 pt-4 border-t">
                <Button
                    color="red"
                    onClick={handleDeleteCouncil}
                    loading={deletingCouncil}
                >
                    Delete
                </Button>
                <Button
                    variant="outline"
                    onClick={() => setShow(null)}
                >
                    Cancel
                </Button>
            </div>
        </ModalLayout>
    )
}
